/** @format */

import React from 'react';

import { Modal, Result, Collapse } from 'antd';
import Images from '../Images';

import './styles.css'

export const Response = {
	open(data, service) {
		Modal.info({
			title: `Respuesta del Servicio`,
			width: 600,
			centered: true,
			content: (
				<>
					{data.statusCode === 200 || data.statusCode === 201 ? (
						<div>
							<Result 
								icon={<Images 
									default="https://storage.googleapis.com/tirx-resources-production/61e47f3d-bff8-41ab-a321-c25e04b956cd.png"
									alt='success image'
								/>} 
								title="Proceso satisfactorio"
								classContent='success-img'
							/>
						</div>
					) : (
						<div>
							<Result status="warning" title={data.message} />
							<Collapse bordered={false}>
								<Collapse.Panel header="Respuesta para desarrolladores">
									<pre>{JSON.stringify(data.data, null, 2)}</pre>
								</Collapse.Panel>
							</Collapse>
						</div>
					)}
				</>
			),
		});
	},
	error(data) {
		Modal.info({
			title: `Respuesta del Servicio`,
			width: 600,
			centered: true,
			content: (
				<>
					<Result status="warning" title={'Atención'} />
					<p>{data.message}</p>
					<Collapse bordered={false}>
						<Collapse.Panel header="Respuesta para desarrolladores">
							<pre>{JSON.stringify(data, null, 2)}</pre>
						</Collapse.Panel>
					</Collapse>
				</>
			),
		});
	},
};
